import { Container } from '../../ui'
import {services} from "../../constants/services";
import AnimateHeight from "react-animate-height";
import {useEffect, useState} from "react";

import { ReactComponent as AbonementIcon } from './assets/images/abonement-icon.svg'

import c from './assets/sass/price.module.scss'

const ANIMATION_DURATION = 500

const Price = () => {
    const [expanded, setExpanded] = useState(false)

    const scrollToTickets = (e) => {
        e.preventDefault()

        document.getElementById('tickets')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToCategory = (id) => {
        if (!expanded) {
            setExpanded(true)

            setTimeout(() => {
                document.getElementById(id)?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                })
            }, ANIMATION_DURATION)

            return
        }

        document.getElementById(id)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    useEffect(() => {
        const handleFooterCategoryClick = (event) => {
            const {id} = event.detail

            if (!expanded) {
                setExpanded(true)

                setTimeout(() => {
                    document.getElementById(id)?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    })
                }, ANIMATION_DURATION)

                return
            }

            document.getElementById(id)?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            })
        }

        window.addEventListener(
            'price:scroll-to-category',
            handleFooterCategoryClick
        )

        return () => {
            window.removeEventListener(
                'price:scroll-to-category',
                handleFooterCategoryClick
            )
        }
    }, [expanded])

    return (
        <section id="price" className={c.component}>
            <Container>
                <div className={c.topTitle}>Прайс</div>
                <div className={c.topSubtitle}>Наши Услуги</div>
                <div className={c.listRow}>
                    <div className={c.listWrapper}>
                        <ul className={c.list}>
                            <li
                                className={c.item}
                                onClick={() => scrollToCategory('bodyCorrection')}
                            >
                                <div className={c.itemInfo}>от 2999 ₽</div>
                                <div className={c.itemTitle}>
                                    Коррекция Фигуры
                                </div>
                            </li>
                            <li
                                className={c.item}
                                onClick={() => scrollToCategory('depilation')}
                            >
                                <div className={c.itemInfo}>от 2000 ₽</div>
                                <div className={c.itemTitle}>
                                    Депиляция
                                </div>
                            </li>
                            <li
                                className={c.item}
                                onClick={() => scrollToCategory('browServices')}
                            >
                                <div className={c.itemInfo}>от 990 ₽</div>
                                <div className={c.itemTitle}>
                                    Ламинирование Бровей
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </Container>
            <div className={c.bottom}>
                <Container>
                    <div className={c.tabsBlock}>
                        <div className={c.tabsTitle}>Все цены</div>
                        <ul className={c.tabs}>
                            {services.map((category) => (
                                <li key={category.id}>
                                    <button
                                        className={c.tabsButton}
                                        onClick={() => scrollToCategory(category.id)}
                                    >
                                        <div className={c.tabsButtonText}>
                                            {category.title}
                                        </div>
                                        <div className={c.tabsButtonCounter}>
                                            {category.items.length}
                                        </div>
                                    </button>
                                </li>
                            ))}
                            <li>
                                <button className={c.tabsButton} onClick={scrollToTickets}>
                                    <div className={c.tabsButtonText}>
                                        Абонементы
                                    </div>
                                    <AbonementIcon
                                        className={c.tabsButtonIcon}
                                    />
                                </button>
                            </li>
                        </ul>
                    </div>
                    <AnimateHeight
                        duration={ANIMATION_DURATION}
                        height={expanded ? 'auto' : 1200}
                    >
                        <div className={c.pricesBlock}>
                            {services.map((category) => (
                                <div
                                    key={category.id}
                                    id={category.id}
                                    className={c.pricesRow}
                                >
                                    <div className={c.pricesCategory}>
                                        {category.title}
                                    </div>
                                    <ul>
                                        {category.items.map((item) => (
                                            <li
                                                key={`${category.id}-${item.id}`}
                                                className={c.pricesItem}
                                            >
                                                <div className={c.pricesItemBold}>
                                                    {item.title}
                                                </div>
                                                <div>
                                                    {item.duration || '—'}
                                                </div>
                                                <div className={c.pricesItemBold}>
                                                    {item.price || '—'}
                                                </div>
                                                <a className={c.pricesItemButton} target="_blank" rel="noopener noreferrer" href={`https://n1798857.yclients.com/company/1597632/personal/select-services?o=s${item.slug}`}>
                                                    Записаться
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                            <div className={c.bottomButtons}>
                                <button
                                    className={c.expand}
                                    onClick={() => setExpanded((prev) => !prev)}
                                >
                                    {expanded ? 'Свернуть' : 'Развернуть все'}
                                </button>
                            </div>
                        </div>
                    </AnimateHeight>
                </Container>
            </div>
        </section>
    )
}

export default Price
